import { ref } from 'vue'
import { defineStore } from 'pinia'
import { fetchMessageCounts } from '@/api/notification'

/** 站内信未读/已读数量：顶栏角标、右侧面板、弹窗 Tab 共用，避免列表 limit 截断导致不一致 */
export const useMessageNoticeStore = defineStore('messageNotice', () => {
  const unreadCount = ref(0)
  const readCount = ref(0)

  async function refreshCounts() {
    try {
      const counts = await fetchMessageCounts()
      unreadCount.value = counts.unreadCount
      readCount.value = counts.readCount
    } catch {
      // 保留上次成功计数，避免失败被当成「没有消息」
    }
  }

  function clear() {
    unreadCount.value = 0
    readCount.value = 0
  }

  return { unreadCount, readCount, refreshCounts, clear }
})
